module.exports = __webpack_public_path__ + "img/no-image-product.5587fbc.svg";